import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col mb-6" }
const _hoisted_2 = { class: "text-xl font-bold py-3" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mx-6" }, "Roles:", -1)
const _hoisted_5 = { class: "flex flex-row mx-3 justify-start space-x-3 my-4 w-full" }
const _hoisted_6 = { class: "flex flex-row justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.keyOption === "edit" ? "Edit Staff" : "Add Staff"), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "flex flex-col mb-4 mx-6"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_TextField, {
            label: item.label,
            typeInput: item.type,
            name: item.name
          }, null, 8, ["label", "typeInput", "name"])
        ])
      ]))
    }), 128)),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item, index) => {
        return (_openBlock(), _createBlock(_component_CheckBoxGroup, {
          key: `item-checkbox-${index + 1}`,
          fieldId: item,
          names: _ctx.checkValues,
          "onUpdate:names": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkValues) = $event)),
          label: item,
          value: item
        }, null, 8, ["fieldId", "names", "label", "value"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        variant: "contained",
        type: "submit",
        label: _ctx.keyOption === 'edit' ? 'Edit Staff' : 'Add Staff',
        disabled: !_ctx.meta.valid || _ctx.checkValues?.length === 0
      }, null, 8, ["label", "disabled"])
    ])
  ], 32))
}